import { Injectable } from "@angular/core";
import {
    ConsumptionHistoryPayload,
    GetConsumptionPayload,
    GetConsumptionPowerPayload,
    GetSmartNowConsumptionEvolutionPayload,
} from "@edp-models/smart-now.model";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class SmartNowService {
    constructor(private apiService: ApiService) {}

    public getSmartNowStatus(contractId: string) {
        return this.apiService.callServicePostToCollection("smartnow.getDeviceInfo", { contractId });
    }


    public getHouseCharacterization(contractId: string) {
        return this.apiService.callServicePostToCollection("smartnow.getHouseCharacterization", {contractId});
    }

    public getEfficiencyEnergetic(contractId: string) {
        return this.apiService.callServicePostToCollection("house.getPeers", {contractId});
    }

    public sendHouseCharacterization(args) {
        return this.apiService.callServicePostToCollection("smartnow.houseCharacterization", args);
    }

    public sendNotification(args) {
        return this.apiService.callServicePostToCollection("smartnow.notification", args);
    }

    public getConsumptionWithDesaggregation(args: GetConsumptionPayload) {
        return this.apiService.callServicePostToCollection("smartnow.consumptionWithDisaggregation", args);
    }

    public getConsumptionWithoutDesaggregation(args: GetConsumptionPayload) {
        return this.apiService.callServicePostToCollection("smartnow.consumptionWithoutDisaggregation", args);
    }

    public getPrediction(contractId: string) {
        return this.apiService.callServicePostToCollection("smartnow.prediction", { contractId });
    }

    public getContractOptimization(contractId: string) {
        return this.apiService.callServicePostToCollection("smartnow.contractOptimization", { contractId });
    }

    public getConsumptionPower(args: GetConsumptionPowerPayload) {
        return this.apiService.callServicePostToCollection("smartnow.powerGraph", args);
    }

    public getConsumptionEvolution(args: GetSmartNowConsumptionEvolutionPayload) {
        return this.apiService.callServicePostToCollection("smartnow.getConsumptionGraph", args);
    }

    public getConsumptionHistory(args: ConsumptionHistoryPayload) {
        return this.apiService.callServicePostToCollection("smartnow.consumptionHistory", args);
    }
}
